module.exports = __webpack_public_path__ + "img/Partnersimg.062ea9b7.png";